import apisauce from 'apisauce';
import { getStore } from 'redux/store';
import AuthActions from 'redux/AuthRedux';
import AppActions from 'redux/AppRedux';

const create = ({ venueId, token }) => {
  const api = apisauce.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    responseType: 'json',
  });

  const authMonitor = (resp) => {
    if (resp.status === 401) {
      const store = getStore();
      store.dispatch(AppActions.setToast('You are not authorized', 'danger'));
      store.dispatch(AuthActions.logout());
    }
  };

  // api.addMonitor(authMonitor);

  // const verifyCode = (code) => api.post(`auth/verify-code`, { code });
  // const sendPhoneCode = (phone) => api.post(`auth/send-phone-code`, { phone });
  const updateUser = (data) => api.post(`auth/update-me`, data);
  const deleteAccount = () => api.delete(`auth/account`);
  // const changePassword = (oldPassword, newPassword) =>
  //   api.post(`auth/change-password`, { oldPassword, newPassword });
  const claimItems = (ticketId, items) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/claim`, { items });
  const updateSplitType = (ticketId, splitType) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/split-type`, { splitType });

  const createTicket = (payload) =>
    api.post(`venues/${venueId}/tickets`, payload);
  const updateTicket = (ticketId, payload) =>
    api.put(`venues/${venueId}/tickets/${ticketId}`, payload);
  const getCurrentTab = () => api.get(`current-ticket`);
  const getUserTicket = () => api.get(`venues/${venueId}/current-ticket`);
  const getAllTicketByTableNumber = (tableNumber) =>
    api.get(`venues/${venueId}/all-tickets-by-table/${tableNumber}`);
  const getVenues = () => api.get(`venues`);
  const loadTransactions = () => api.get(`transactions`);
  const loadTransaction = (transactionId) =>
    api.get(`transactions/${transactionId}`);
  const loadTransactionPublic = (transactionId) =>
    api.get(`transactions-public/${transactionId}`);
  const getTicket = (ticketId) =>
    api.get(`venues/${venueId}/tickets/${ticketId}`);
  const getClaims = (ticketId) =>
    api.get(`venues/${venueId}/tickets/${ticketId}/claim`);
  const getMenuItems = () => api.get(`venues/${venueId}/menu-items`);
  const getMenuCategories = () => api.get(`venues/${venueId}/menu-categories`);
  const deleteTicket = (ticketId) =>
    api.delete(`venues/${venueId}/tickets/${ticketId}`);
  const getTicketUsers = (ticketId) =>
    api.get(`venues/${venueId}/tickets/${ticketId}/users`);
  const splitTab = (ticketId) =>
    api.put(`venues/${venueId}/tickets/${ticketId}/split`, {});
  const setDefaultCard = (cardId) =>
    api.post(`/payment/card/${cardId}/set-default`, {});
  const loadCards = () => api.get(`/payment/cards`);
  const saveCard = (paymentToken) =>
    api.post(`/payment/card/${paymentToken}`, {});
  const preauthorizeCard = () =>
    api.post(`/payment/card/preauthorize-card`, {});
  const deleteCard = (cardId) => api.delete(`/payment/card/${cardId}`, {});
  const pay = (ticketId, body) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/payment`, body);
  const loadPromotions = () => api.get(`promotions`);
  const applyPromotion = (ticketId, promotionId) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/promotions`, {
      promotionId,
    });
  const applyOfferDiscount = (ticketId, discountId) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/offer-discount`, {
      discountId,
    });

  /** @deprecated */
  const setOptInProgram = (programId) =>
    api.post(`loyalty-points/${programId}`, {});

  /** @deprecated */
  const deleteLoyaltyPoint = (programId) =>
    api.delete(`loyalty-points/${programId}`);
  const getLoyaltyPoints = () => api.get('loyalty-points');
  const getRewardLevels = () => api.get('reward-levels');
  const setRedeem = (ticketId, body) =>
    api.post(`venues/${venueId}/tickets/${ticketId}/redeem`, body);
  const getLoyaltyPrograms = () => api.get('loyalty-programs');
  // const getLoyaltyAutoOffers = () => api.get('loyalty-auto-offers'); @deprecated
  // const getLoyaltyAnnualOffers = () => api.get('loyalty-annual-offers'); @deprecated
  // const setActivateOffer = (offerId) =>
  //   api.post(`loyalty-auto-offers/${offerId}/activate`, {}); @deprecated
  const setDeactivateOffer = (offerId) =>
    api.post(`loyalty-auto-offers/${offerId}/deactivate`, {});
  const setRegistToken = (pushToken) =>
    api.post(`auth/register-push-token`, { token: pushToken });

  return {
    getVenues,
    claimItems,
    updateSplitType,
    getCurrentTab,
    getAllTicketByTableNumber,
    updateUser,
    // changePassword,
    // verifyCode,
    // sendPhoneCode,
    createTicket,
    updateTicket,
    getUserTicket,
    getClaims,
    deleteTicket,
    getTicket,
    getTicketUsers,
    splitTab,
    loadTransactions,
    loadTransaction,
    loadTransactionPublic,
    setDefaultCard,
    loadCards,
    saveCard,
    preauthorizeCard,
    deleteCard,
    pay,
    getMenuItems,
    getMenuCategories,
    deleteAccount,
    loadPromotions,
    applyPromotion,
    applyOfferDiscount,
    setOptInProgram,
    getLoyaltyPoints,
    deleteLoyaltyPoint,
    getLoyaltyPrograms,
    getRewardLevels,
    setRedeem,
    // getLoyaltyAutoOffers,
    // getLoyaltyAnnualOffers,
    // setActivateOffer,
    setDeactivateOffer,
    setRegistToken,
  };
};

export default create;
